export const ROUTES = {
  clinicalCoding: {
    parentPath: "admin",
    slug: "clinical-coding",
    route: "/admin/clinical-coding",
  },
};
